<template>
  <el-table
    class="retention-table"
    :data="countTable"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      :prop="dataType != 'itemTag' ? 'skuId' : 'classifyName'"
      :label="firstColumnLabel"
      width="180"
      align="center"
    >
    </el-table-column>
    <el-table-column
      prop="skuName"
      :label="secondColumnLabel"
      width="180"
      align="center"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.skuName" :lines="1" />
      </template>
    </el-table-column>
    <el-table-column
      prop="payDate"
      label="付款日期"
      width="120"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="buyCount"
      label="购买人数"
      width="120"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="buyAmount"
      label="购买金额"
      width="120"
      align="center"
    ></el-table-column>
    <!-- 按月-->
    <template v-if="tableType == 0">
      <el-table-column
        label="当月"
        align="center"
      >
        <el-table-column
          prop="month0Count"
          label="留存人数"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="month0Amount"
          label="留存金额"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="month0Ratio"
          label="留存率"
          width="100"
          align="center"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        v-for="i in 12 * nowYearNum"
        :key="'m' + i"
        :label="'第' + i + '个月'"
        align="center"
      >
        <el-table-column
          :prop="'month' + i + 'Count'"
          label="留存人数"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          :prop="'month' + i + 'Amount'"
          label="留存金额"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          :prop="'month' + i + 'Ratio'"
          label="留存率"
          width="100"
          align="center"
        ></el-table-column>
      </el-table-column>
    </template>
    <!-- 按季度 -->
    <template v-if="tableType == 1">
      <el-table-column
        label="当前季度"
        align="center"
      >
        <el-table-column
          prop="quarter0Count"
          label="留存人数"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="quarter0Amount"
          label="留存金额"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="quarter0Ratio"
          label="留存率"
          width="100"
          align="center"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        v-for="i in 4 * nowYearNum"
        :key="'q' + i"
        :label="'第' + i + '季度'"
        align="center"
      >
        <el-table-column
          :prop="'quarter' + i + 'Count'"
          label="留存人数"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          :prop="'quarter' + i + 'Amount'"
          label="留存金额"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          :prop="'quarter' + i + 'Ratio'"
          label="留存率"
          width="100"
          align="center"
        ></el-table-column>
      </el-table-column>
    </template>
    <!-- 按年 -->
    <template v-if="tableType == 2">
      <el-table-column
        label="当前年"
        align="center"
      >
        <el-table-column
          prop="year0Count"
          label="留存人数"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="year0Amount"
          label="留存金额"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="year0Ratio"
          label="留存率"
          width="80"
          align="center"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        v-for="i in nowYearNum"
        :key="'y' + i"
        :label="'第' + i + '年'"
        align="center"
      >
        <el-table-column
          :prop="'year' + i + 'Count'"
          label="留存人数"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          :prop="'year' + i + 'Amount'"
          label="留存金额"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          :prop="'year' + i + 'Ratio'"
          label="留存率"
          width="100"
          align="center"
        ></el-table-column>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
import mixins from "../../../mixins/index.js";
import Empty from "../../../components/empty.vue";

export default {
  name: "retentionTable",
  mixins: [mixins],
  components: {
    Empty,
    textOverflowTooltip: () => import("@/components/ai/components/prefabricateReport/components/textOverflowTooltip.vue"),
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    dataType: {
      type: String,
      default: "sku",
    },
    reportParams: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    countTable() {
      const tableList = (this.tableData || []).map((item) => {
        const row = {
          skuId: item.skuId,
          skuName: item.skuName,
          classifyId: item.classifyId || "",
          classifyName: item.classifyName || "",
          payDate: item.payDate,
          buyCount: item.buyCount,
          buyAmount: item.buyAmount,
        };
        if (item.retentionVOList && item.retentionVOList.length > 0) {
          item.retentionVOList.forEach((subItem) => {
            const prefix = this.tableType == 0 ? "month" : this.tableType == 1 ? "quarter" : 'year';
            row[`${prefix}${subItem.index}Count`] = subItem.repurchaseCount;
            row[`${prefix}${subItem.index}Amount`] = subItem.repurchaseAmount;
            row[`${prefix}${subItem.index}Ratio`] = subItem.repurchaseRatio;
          });
        }
        return row;
      });
      const ignoreKeys = ["skuId", "skuName", "classifyId", "classifyName", "payDate"];
      return tableList.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          // 不需要处理得字段直接返回
          if (ignoreKeys.includes(key)) {
            newRow[key] = row[key];
            return;
          }
          // Ratio 字段 → 百分比
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else if (key.includes("Count") || key.includes("Amount")) {
            // 其他数值 → 普通数字
            newRow[key] = this.formatNumber(row[key]);
          } else {
            // 其他字段 → 直接返回
            newRow[key] = row[key];
          }
        });
        return newRow;
      });
    },
    firstColumnLabel() {
      const map = {
        sku: "skuId",
        spu: "商品Id",
        category: "类目Id",
        sellerCategory: "类目Id",
        itemTag: "标签分类",
      };
      return map[this.dataType] || "";
    },
    secondColumnLabel() {
      const map = {
        sku: "商品名称",
        spu: "商品名称",
        category: "类目名称",
        sellerCategory: "类目名称",
        itemTag: "标签名称",
      };
      return map[this.dataType] || "";
    },
    tableType() {
      return this.reportParams.dimension || 0;
    },
    nowYearNum() {
      return this.reportParams.retentionPeriod || 1;
    },
    // prevReportView() {
    //   return this.reportParams.reportView || 0;
    // },
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 按关联率时，不需要合并
      // if (this.prevReportView == 1) {
      //   return {
      //     rowspan: 1,
      //     colspan: 1,
      //   };
      // }
      // 按年度，不需要合并
      if (this.tableType == 2) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
      // 需要合并的字段列表
      const mergeFields = this.dataType != 'itemTag' ? ["skuId", "skuName"] : ["skuId", "skuName", "classifyId", "classifyName"];
      // 获取当前列的prop
      const prop = column.property;
      // 如果不是需要合并的字段，不进行合并
      if (!mergeFields.includes(prop)) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
      // 查找相同数据的行范围
      if (rowIndex > 0) {
        const prevRow = this.countTable[rowIndex - 1];
        const currentRow = this.countTable[rowIndex];
        // 检查当前行和前一行是否需要合并
        let shouldMerge = true;
        for (const field of mergeFields) {
          if (prevRow[field] !== currentRow[field]) {
            shouldMerge = false;
            break;
          }
        }
        if (shouldMerge) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      // 计算当前相同数据的行数
      let rowspan = 1;
      for (let i = rowIndex + 1; i < this.countTable.length; i++) {
        const nextRow = this.countTable[i];
        let isSame = true;
        for (const field of mergeFields) {
          if (this.countTable[rowIndex][field] !== nextRow[field]) {
            isSame = false;
            break;
          }
        }
        if (isSame) {
          rowspan++;
        } else {
          break;
        }
      }
      return {
        rowspan: rowspan,
        colspan: 1,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .retention-table .el-table__empty-block {
  width: auto !important;
}
</style>
